import React from 'react';

import { Input } from 'antd';

import { NwFakeFormItem } from '@components/Gui/NwForm/NwFakeFormWrapper';
import NwIcon from '@components/Gui/NwIcon';
import NwUpload from '@components/Gui/NwUpload';

import { ARTICLE_FILE_LINK_TEXT_DEFAULT } from '@containers/Art/Articles/Articles.constants';
import { ArtMediaFieldControl, ArtMediaUploadArea } from '@containers/Art/ArtMediaSourceFields.styles';
import { getArtMediaDocumentId, getArtStoredMediaUrl } from '@containers/Art/ArtDocuments';

import { StyledArticleFilePreview } from './ArticleEditorFileBlock.styles';

import { byPrefixAndName } from '@awesome.me/kit-d6dae216cd/icons';

const getFileNameFromUrl = (url) => {
    if (!url) return 'Uploaded file';
    try {
        return decodeURIComponent(String(url).split('/').pop().split('?')[0]) || 'Uploaded file';
    } catch (error) {
        return 'Uploaded file';
    }
};

const ArticleEditorFileBlock = ({ block, column, row, onChangeLinkText, onUploadFileEnd }) => {
    const media = block.Media || {};
    const documentId = getArtMediaDocumentId(media);
    const fileUrl = getArtStoredMediaUrl(media);

    return (
        <>
            <div className="media-action">
                <NwUpload
                    localUpload
                    maxCount={1}
                    maxSize={200}
                    showList={false}
                    types={['document']}
                    onUploadEnd={onUploadFileEnd(row.ID, column.ID, block.ID)}
                >
                    <ArtMediaUploadArea>
                        <NwIcon icon={byPrefixAndName.fasl['file-pdf']} />
                        {documentId ? 'click or drag to replace the PDF file' : 'click or drag to upload a PDF file'}
                    </ArtMediaUploadArea>
                </NwUpload>
            </div>

            {documentId && fileUrl && (
                <StyledArticleFilePreview href={fileUrl} rel="noopener noreferrer" target="_blank">
                    <NwIcon icon={byPrefixAndName.fasl['file-pdf']} />
                    <span>{getFileNameFromUrl(fileUrl)}</span>
                </StyledArticleFilePreview>
            )}

            <ArtMediaFieldControl>
                <NwFakeFormItem
                    label="Link text"
                    control={
                        <Input
                            autoComplete="off"
                            placeholder={ARTICLE_FILE_LINK_TEXT_DEFAULT}
                            value={media.LinkText || ''}
                            onChange={(event) => onChangeLinkText(row.ID, column.ID, block.ID, event.target.value)}
                        />
                    }
                />
            </ArtMediaFieldControl>
        </>
    );
};

export default ArticleEditorFileBlock;
